import appAxios from '../../utils/appAxios';
export default {
    namespaced: true,
    state: {
        permission: {
            id: 0,
            systemName: null,
            selected: false
        },
        permissionList: [],
        userGroup: {
            id: 0,
            name: null,
            permissions: [],
            active: true,

        },
        userGroupList: [],
        loading: false,
        recordsTotal: 0,

    },
    getters: {
        _getPermissions: (state) => {
            return state.permissionList
        },

        _getTotalRecords: (state) => {

            return state.recordsTotal
        },
        _getLoading: (state) => {
            return state.loading
        },


        _getUserGroup: (state) => {
            return state.userGroupList
        },
    },
    mutations: {

        SET_PERMISSIONS: (state, payload) => {
            state.permissionList = payload;
        },

        SET_USERGROUPS: (state, Data) => {
            state.userGroupList = []
            state.recordsTotal = Data.TotalItemsCount
            if (Data.ListItems.length > 0) {
                Data.ListItems.forEach(item => {
                    state.userGroupList.push(item)
                });
            }
            state.loading = false
        }

    },

    actions: {
        async GET_PERMISSIONS({ commit }, payload) {
            await appAxios.get(`/admin/Permission/GetPermissions/${payload}`).then(response => {
                if (response.data.Success) {
                    commit("SET_PERMISSIONS", response.data.Data)
                }
            })
        },
        async GET_ALL_USERGROUPS({ commit, state }, payload) {
            state.loading = true;
            await appAxios.post("/admin/UserGroup/GetAll", payload).then(response => {
                commit("SET_USERGROUPS", response.data.Data)
            }).catch(() => state.loading = false)
        },

        async GET_USERGROUPS(context, payload) {
            return new Promise(resolve => {
                appAxios.get(`/admin/UserGroup/Get/${payload}`).then(response => {
                    if (response.data.Success) {
                        resolve(response.data.Data)
                    } else {
                        resolve(null)
                    }
                })
            })
        },

        async ADD_USERGROUPS(context, payload) {
            await appAxios.post("/admin/UserGroup/Create", payload).then(response => {
                if (response.data.Success == true) {
                    context.dispatch("GET_ALL_USERGROUPS", { page: 1, pageSize: 10 }
                    )
                }
                else { return null }
            })
        },

        async DELETE_USERGROUPS({ dispatch }, payload) {
            await appAxios.post("/admin/UserGroup/Delete", payload[0]).then(response => {
                if (response.data.Success) {
                    dispatch("GET_ALL_USERGROUPS", payload[1])
                }
            })

        },
        async UPDATE_USERGROUPS({ dispatch }, payload) {
            await appAxios.post("/admin/UserGroup/Update", payload).then(response => {
                if (response.data.Success) {
                    dispatch("GET_ALL_USERGROUPS", { page: 1, pageSize: 10 })
                }
            })

        },




    }

}